import React, { useCallback } from 'react'
import EDInputText from '../../../../../Component/EnhancedData/EDInputText'
import { DataWithKey, TextFieldDefinition } from '../../../../../Component/EnhancedData/Types'
import { ED_FIELD_SPEC } from '../../../../../Helper/EnhancedData/Constants'
import { toConsumableNumber } from '../../../../../Helper/EnhancedData/EnhancedDataUtils'

interface Props {
  value: number
  surchargeAmount: number
  onInputChange: (name: string, value: any) => void
  fieldDefinition: DataWithKey<TextFieldDefinition>
  emptyColSpan?: number
  onInputError?: (fieldName: string, errorMessage: string | null) => void
}

export default function SurchargeTaxAmountRow (props: Props): React.JSX.Element {
  const { onInputChange, onInputError, fieldDefinition, emptyColSpan = 4 } = props
  const surchargeAmount: number = toConsumableNumber(props.surchargeAmount)
  const surchargeTaxAmount: number = toConsumableNumber(props.value)

  // surcharge tax amount will be a readonly field when surcharge amount is zero
  const isSurchargeApplied: boolean = surchargeAmount > 0

  const maxColSpan = 7
  const reservedColSpan = maxColSpan - emptyColSpan

  // validate surcharge tax amount
  const validateSurchargeTaxAmount = useCallback((name: string, value: number): void => {
    const isInvalidTaxAmount = value < 0 || value >= surchargeAmount
    if (isInvalidTaxAmount && onInputError) {
      onInputError(name, ED_FIELD_SPEC.level3.surchargeTaxAmount.errorMessage)
    }
  }, [onInputError, surchargeAmount])

  // Capture Surcharge Tax Amount input change and validate
  const handleInputChange = useCallback((name: string, value: any): void => {
    onInputChange(name, value)
    validateSurchargeTaxAmount(name, toConsumableNumber(value))
  }, [onInputChange, validateSurchargeTaxAmount])

  return (
    <tr className="subtotal-row">
      <td colSpan={emptyColSpan}></td>
      <td colSpan={reservedColSpan} className="subtotal-input-cell">
        <EDInputText
          value={surchargeTaxAmount}
          onInputChange={handleInputChange}
          onInputError={onInputError}
          fieldDefinition={fieldDefinition}
          prefixInput={'$'}
          separator={'+'}
          className={'subtotal-input label-left'}
          runValidationNow={false}
          readOnly={!isSurchargeApplied}
        />
      </td>
    </tr>
  )
}
